export default "__VITE_ASSET__f03eeed6__"